import client from "../api-hooks/client";
import { ApiResponse, TPlatformAdmin } from "../types";

export const authApi = {
  login: (email: string, password: string) =>
    client.post<ApiResponse<{ token: string; admin: TPlatformAdmin }>>("/auth/login", { email, password }),

  me: () => client.get<ApiResponse<TPlatformAdmin>>("/auth/me"),

  logout: () => client.post("/auth/logout"),

  changePassword: (current_password: string, new_password: string) =>
    client.post("/auth/change-password", { current_password, new_password }),

  verifyTwoFactor: async (temp_token: string, otp_token: string) => {
    return client.post("/auth/2fa/verify-login", { temp_token, otp_token });
  },
};
